import { capitalizeText } from '@trwl/util';
import copy from 'copy-to-clipboard';
import { toast } from 'sonner';

export const DescriptionItem = ({
  propertyKey,
  propertyValue,
}: {
  propertyKey: string;
  propertyValue: string;
}) => {
  return (
    <div>
      <span
        className={'cursor-pointer text-lg'}
        onClick={() => {
          copy(propertyValue);
          toast.success(`Вы скопировали характеристику продукта.`);
        }}
      >
        <span className="text-[#B1B1B1] font-[500]">
          {capitalizeText(propertyKey)}
        </span>
        <span> : </span>
        <span>{capitalizeText(propertyValue)}</span>
      </span>
    </div>
  );
};
